<div class="sections-layout">
  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="space-around">
    @for (section of sections; track $index; let isFirst = $first; let isLast = $last) {
      <div fxFlex="{{flexAmount()}}">
        @if (section && section.length === 1) {
          <div
            class="sections-layout__group-container"
            [ngClass]="getAlignedClass(isFirst, isLast) + ' ' + applyCardMinWidth(section)"
            fxLayout="column"
            fxLayoutAlign="space-around">
            <stat-section class="sections-layout__aligned-groups"
              [data]="getSectionData(section[0])"
              [isPrimary]="true"
              [category]="category"
              [section]="section[0]"
              [isMobile]="isMobile">
            </stat-section>
          </div>
        }
        @if (section && section.length > 1) {
          <div
            fxLayout="column"
            fxLayoutAlign="space-between"
            class="sections-layout__group-container sections-layout__equal-card-size"
            fxFlex>
            <stat-section class="sections-layout__top-grouped-row"
              [data]="getSectionData(section[0])"
              [isPrimary]="true"
              [category]="category"
              [section]="section[0]"
              [isMobile]="isMobile">
            </stat-section>
            <div fxLayout="row"
              fxLayoutAlign="space-around"
             [ngClass]="{'sections-layout__bottom-grouped-row': section.length > 2,
                        'sections-layout__single-grouped-row': section.length <= 2}">
          @for (segment of getAllButFirstSection(section); track $index; let isFirst = $first) {
<div
               fxFlex [ngClass]="getBorderClass(isFirst)">
                  <stat-section [data]="getSectionData(segment)"
                    [category]="category"
                    [isPrimary]="section.length <= 2"
                    [section]="segment"
                    [isMobile]="isMobile">
                  </stat-section>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
